import {ArrowBack as ArrowBackIcon} from '@mui/icons-material';
import {Button, DialogActions, Divider} from '@mui/material';
import {func, node} from 'prop-types';
import React from 'react';

export const ButtonBar = ({children, onBack}) => (
  <>
    <Divider />
    <DialogActions sx={{paddingY: 1, paddingX: 2}}>
      {onBack && (
        <Button
          startIcon={<ArrowBackIcon />}
          disabled={onBack === undefined}
          onClick={() => onBack()}
          sx={{marginRight: 'auto'}}
        >
          Back
        </Button>
      )}
      {children}
    </DialogActions>
  </>
);

ButtonBar.propTypes = {
  children: node,
  onBack: func,
};

export default ButtonBar;
